import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'stakeholders',
  setup: function setup(__props) {
    var dataTableStakeholder = ref(null);
    onMounted(function () {
      var _dataTableStakeholder;
      if (dataTableStakeholder !== null && dataTableStakeholder !== void 0 && (_dataTableStakeholder = dataTableStakeholder.value) !== null && _dataTableStakeholder !== void 0 && _dataTableStakeholder.refetch) {
        dataTableStakeholder.value.refetch();
      }
    });
    var onStakeholderAdded = function onStakeholderAdded() {
      var _dataTableStakeholder2;
      if (dataTableStakeholder !== null && dataTableStakeholder !== void 0 && (_dataTableStakeholder2 = dataTableStakeholder.value) !== null && _dataTableStakeholder2 !== void 0 && _dataTableStakeholder2.refetch) {
        dataTableStakeholder.value.refetch();
      }
    };
    return {
      __sfc: true,
      dataTableStakeholder: dataTableStakeholder,
      onStakeholderAdded: onStakeholderAdded
    };
  }
});